module.exports = __webpack_public_path__ + "img/icon-christmas-7.50bb8b1e.svg";